/* eslint-disable react/prop-types */

import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from 'react-router-dom';

const HistoryLog = ({ logsData }) => {
  // logsData içinde "logs" anahtarı olup olmadığını kontrol et
  const logs = logsData?.logs || [];

  if (logs?.length === 0) {
    return <></>;
  }



  return (
    <div className="history-log">
      <h2>İşlem Geçmişi</h2>
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Kullanıcı</th>
            <th>İşlem</th>
            <th>Model</th>
            <th>Tarih</th>
            <th>Eski Veri</th>
            <th>Yeni Veri</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log, index) => (
            <tr key={log.id}>
              <td>{index + 1}</td>
              <td>
                <img
                  src={log.user.personel_fotograf}
                  alt={log.user.name}
                  width="40"
                  height="40"
                  style={{ borderRadius: "50%", marginRight: "10px" }}
                />
                {log.user.name} {log.user.surname} ({log.user.trt_arabi_unvan || "Unvan Yok"})
              </td>
              <td>{log.action === "create" ? "Oluşturma" : log.action === "update" ? "Güncelleme" :  "Silme"}</td>
              <td>{log.model_name}</td>
              <td>{new Date(log.timestamp).toLocaleString()}</td>
              <td>
                {log.action === "update" ? (
                  <pre>{JSON.stringify(log.data.old_data, null, 2)}</pre>
                ) : (
                  "-"
                )}
              </td>
              <td>
                {log.action === "update" ? (
                  <pre>{JSON.stringify(log.data.new_data, null, 2)}</pre>
                ) : (
                  <pre>{JSON.stringify(log.data, null, 2)}</pre>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>


    </div>
  );
};

export default HistoryLog;
